(function ($) {
  $(document).ready(function () {
    $('.wk-list-3x a').addClass('stretched-link');
  });
})(jQuery);
